export default "__VITE_ASSET__BRrWgljv__"